<template>
  <div class="App__container">
    <div class="App__NavBar" v-if="$store.getters.isSignedIn">
      <NavBar />
    </div>
    <main class="App__main">
      <router-view />
    </main>
    <div class="App__envBadge" v-if="envName !== 'production'">
      {{ envName }}
    </div>
  </div>
</template>

<script setup>
import NavBar from "@/components/NavBar.vue"

const envName = process.env.VUE_APP_ENV_NAME || "production"
</script>

<style lang="scss" scoped>
.App__container {
  background: var(--background);
  color: var(--text-dark);
}
.App__NavBar {
  position: fixed;
  top: 0;
  z-index: 99999999;
  width: 100%;
}
// .App__main {
// }
.App__envBadge {
  position: fixed;
  bottom: 0.75rem;
  left: 0.75rem;
  z-index: 99999999;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  background: #e6a23c;
  color: var(--white);
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  pointer-events: none;
}
</style>
